import { a as MenuButton$1 } from '../../reach-menu-button.esm-22bcdd5f.js';
import { themed } from '@indeed/ifl-css';
import 'react';
import '../../reach-popover.esm-c19739dd.js';
import 'react-dom';

const StyledMenuButton = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "ex6cvhv0"
} : {
  styleProps: [],
  target: "ex6cvhv0",
  label: "StyledMenuButton"
})(() => ({
  bg: "transparent",
  border: "none",
  fontFamily: "default",
  fontSize: 3,
  ":focus": {
    outline: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnVCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtnQyIsImZpbGUiOiJNZW51QnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1lbnVCdXR0b24gYXMgUmVhY2hNZW51QnV0dG9uIH0gZnJvbSBcIkByZWFjaC9tZW51LWJ1dHRvblwiO1xuaW1wb3J0IHR5cGUgKiBhcyBQb2x5bW9ycGhpYyBmcm9tIFwiLi4vLi4vdHlwZXMvcmVhY2gvcG9seW1vcnBoaWNcIjtcbmltcG9ydCB0eXBlIHsgTWVudUJ1dHRvblByb3BzIH0gZnJvbSBcIi4uLy4uL3R5cGVzL3JlYWNoL21lbnUtYnV0dG9uXCI7XG5pbXBvcnQgeyB0aGVtZWQsIFN0eWxlUHJvcHMgfSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51QnV0dG9uID0gdGhlbWVkKFwiYnV0dG9uXCIsIHtcbiAgc3R5bGVQcm9wczogW11cbn0pPFN0eWxlUHJvcHM+KCgpID0+ICh7XG4gIGJnOiBcInRyYW5zcGFyZW50XCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGZvbnRGYW1pbHk6IFwiZGVmYXVsdFwiLFxuICBmb250U2l6ZTogMyxcbiAgXCI6Zm9jdXNcIjoge1xuICAgIG91dGxpbmU6IFwibm9uZVwiXG4gIH1cbn0pKTtcblxuLyoqXG4gKiBAZGVwcmVjYXRlZCBUaGUgYE1lbnVgIGNvbXBvbmVudCB3aWxsIGJlIHJlbW92ZWQgaW4gSUZMIDcuXG4gKiBTZWUgdGhlIElGTCA3IHByZXBhcmF0aW9uIGd1aWRlIGZvciBtb3JlIGluZm9ybWF0aW9uOiBodHRwczovL2xpbmsuaW5kZWVkLnRlY2gvaWZsLTctcHJlcC1ndWlkZVxuICovXG5cbmV4cG9ydCBjb25zdCBNZW51QnV0dG9uID0gU3R5bGVkTWVudUJ1dHRvbi53aXRoQ29tcG9uZW50KFxuICBSZWFjaE1lbnVCdXR0b24gYXMgUG9seW1vcnBoaWMuRm9yd2FyZFJlZkNvbXBvbmVudDxcImJ1dHRvblwiLCBNZW51QnV0dG9uUHJvcHM+XG4pO1xuXG5NZW51QnV0dG9uLmRpc3BsYXlOYW1lID0gXCJNZW51QnV0dG9uXCI7XG4iXX0= */");

/**
 * @deprecated The `Menu` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const MenuButton = StyledMenuButton.withComponent(MenuButton$1, process.env.NODE_ENV === "production" ? {
  target: "ex6cvhv1"
} : {
  target: "ex6cvhv1",
  label: "MenuButton"
});
MenuButton.displayName = "MenuButton";

export { MenuButton, StyledMenuButton };
